// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1RQek","loaderOuter":"PageOverlayLoader_loaderOuter__3OArr"};